import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { CommonModule } from '@angular/common';
import { LandingRequerimientosComponent } from './landing-requerimientos.component';
import { AdminPulsecheckComponent } from './admin-pulsecheck/admin-pulsecheck.component';
import { AdminFocusComponent } from './admin-focus/admin-focus.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';


// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
const rutas: Routes = [
  // Landing certificar
{
      path     : 'requerimentsLandingcertify_0',
      component: LandingRequerimientosComponent,
      data: {producto : '1'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingcertify_1',
      component: LandingRequerimientosComponent,
      data: {producto : 'c1'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingcertify_2',
      component: LandingRequerimientosComponent,
      data: {producto : 'c2'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingcertify_3',
      component: LandingRequerimientosComponent,
      data: {producto : 'c3'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingcertify_4',
      component: LandingRequerimientosComponent,
      data: {producto : 'c4Plata'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingcertify_6',
      component: LandingRequerimientosComponent,
      data: {producto : 'c6'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingPulse_t1',
      component: LandingRequerimientosComponent,
      data: {producto : 'p1'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingmeasurement_t7',
      component: LandingRequerimientosComponent,
      data: {producto : 'm7'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingPulse',
      component: LandingRequerimientosComponent,
      data: {producto : '3'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingNom35',
      component: LandingRequerimientosComponent,
      data: {producto : 'Nom3'},
      canActivate: [AuthGuard],
  },
  {
    path     : 'requerimentsLandingPulse/adminpulsecheck',
    component: AdminPulsecheckComponent,
  },
  {
    path     : 'requerimentsLandingPulse_t1/adminpulsecheck',
    component: AdminPulsecheckComponent,
  },
  {
      path     : 'requerimentsLandingfocus',
      component: LandingRequerimientosComponent,
      data: {producto : 'f1'},
      canActivate: [AuthGuard],
  },
  {
    path     : 'requerimentsLandingfocus/adminfocusarea',
    component: AdminPulsecheckComponent,
  },
  // Landing certificar v2

  // Landing medir
  {
      path     : 'requerimentsLandingmeasurement',
      component: LandingRequerimientosComponent,
      data : {producto : '2'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t1',
      component: LandingRequerimientosComponent,
      data : {producto : 'm1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t2',
      component: LandingRequerimientosComponent,
      data : {producto : 'm2'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t3',
      component: LandingRequerimientosComponent,
      data : {producto : 'm3'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t4',
      component: LandingRequerimientosComponent,
      data : {producto : 'm4'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t5',
      component: LandingRequerimientosComponent,
      data : {producto : 'm5'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingmeasurement_t6',
      component: LandingRequerimientosComponent,
      data : {producto : 'm6'},
      canActivate: [AuthGuard]
  },
  // // Landing Focus
  // {
  //   path     : 'requerimentsLandingfocus',
  //   component: LandingRequerimientosComponent,
  //   data : {producto : '4'},
  //   canActivate: [AuthGuard]
  // },
  {
    path     : 'requerimentsLandingFocus/adminfocus',
    component: AdminFocusComponent,
  },
  // // Landing Pulse
  // {
  //     path     : 'pulse',
  //     component: LandingRequerimientosComponent,
  //     data : {producto : '3'},
  //     canActivate: [AuthGuard]
  // },
  // {
  //     path     : 'NOM35',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35'},
  //     canActivate: [AuthGuard]
  //
  // },{
  //     path     : 'NOM35-ENC',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35-ENC'},
  //     canActivate: [AuthGuard]
  //
  // },{
  //     path     : 'NOM35-EXP',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35-EXP'},
  //     canActivate: [AuthGuard]
  // }
  //   //Turquía
  // ,{
  //       path     : 'culture_tr1',
  //       component: LandingculturetrComponent,
  //       data : {producto : 'culture1'},
  //       canActivate: [AuthGuard]
  // },{
  //       path     : 'culture_tr2',
  //       component: LandingculturetrComponent,
  //       data : {producto : 'culture2'},
  //       canActivate: [AuthGuard]
  // },{
  //       path     : 'culture_tr3',
  //       component: LandingculturetrComponent,
  //       data : {producto : 'culture3'},
  //       canActivate: [AuthGuard]
  // },
  //
  // //MEXICO CA
  // {
  //       path     : 'culture_MX1',
  //       component: LandingculturemxComponent,
  //       data : {producto : 'culture5.0'},
  //       canActivate: [AuthGuard]
  // },{
  //       path     : 'culture_MX2',
  //       component: LandingculturemxComponent,
  //       data : {producto : 'cultureCR'},
  //       canActivate: [AuthGuard]
  // },{
  //       path     : 'culture_MX3',
  //       component: LandingculturemxComponent,
  //       data : {producto : 'cultureGoFlow'},
  //       canActivate: [AuthGuard]
  // },
  // {
  //       path     : 'culture_MX4',
  //       component: LandingculturemxComponent,
  //       data : {producto : 'culturePanama'},
  //       canActivate: [AuthGuard]
  // },
  // {
  //       path     : 'culture_MX5',
  //       component: LandingculturemxComponent,
  //       data : {producto : 'cultureSP'},
  //       canActivate: [AuthGuard]
  // },
  //
  // //CHINA
  // {
  //   path     : 'culture_ch1',
  //   component: LandingculturechComponent,
  //   data : {producto : 'culture_ch1'},
  //   canActivate: [AuthGuard]
  // },{
  //   path     : 'culture_ch2',
  //   component: LandingculturechComponent,
  //   data : {producto : 'culture_ch2'},
  //   canActivate: [AuthGuard]
  // },{
  //   path     : 'culture_ch3',
  //   component: LandingculturechComponent,
  //   data : {producto : 'culture_ch3'},
  //   canActivate: [AuthGuard]
  // },
  //
  // //España
  //
  // {
  //   path     : 'culture_esp1',
  //   component: Landingculture_espComponent,
  //   data : {producto : 'culture_esp1'},
  //   canActivate: [AuthGuard]
  // },{
  //   path     : 'culture_esp2',
  //   component: Landingculture_espComponent,
  //   data : {producto : 'culture_esp2'},
  //   canActivate: [AuthGuard]
  // },{
  //   path     : 'culture_esp3',
  //   component: Landingculture_espComponent,
  //   data : {producto : 'culture_esp3'},
  //   canActivate: [AuthGuard]
  // },
  {
      path     : 'requerimentsLandingamco_1',
      component: LandingRequerimientosComponent,
      data: {producto : 'am1'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingtraba_digno',
      component: LandingRequerimientosComponent,
      data: {producto : 'td1'},
      canActivate: [AuthGuard],
  },
  {
      path     : 'requerimentsLandingprimer_emple',
      component: LandingRequerimientosComponent,
      data: {producto : 'pe1'},
      canActivate: [AuthGuard],
  },

];

@NgModule({
  declarations: [
    LandingRequerimientosComponent,
    AdminPulsecheckComponent,
    AdminFocusComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    FlexLayoutModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule
  ]
})
export class LandingRequerimientosModule { }
